"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeploymentResponse = void 0;
var DeploymentResponse;
(function (DeploymentResponse) {
    let state;
    (function (state) {
        state["PENDING"] = "pending";
        state["OUTREACHING"] = "outreaching";
        state["OUTREACHED"] = "outreached";
        state["VIEWED"] = "viewed";
        state["ACCEPTED"] = "accepted";
        state["RUNNING"] = "running";
        state["ADJUSTMENT_APPROVAL"] = "adjustment_approval";
        state["PAYMENT_PROCESSING"] = "payment_processing";
        state["OUTREACH_TIMEOUT"] = "outreach_timeout";
        state["OUTREACH_REJECTED"] = "outreach_rejected";
        state["CANCELED"] = "canceled";
        state["FAILED_TO_MEET_GOALS"] = "failed_to_meet_goals";
        state["COMPLETED"] = "completed";
        state["ABUSE_IDENTIFIED"] = "abuse_identified";
    })(state = DeploymentResponse.state || (DeploymentResponse.state = {}));
    let outreachMethod;
    (function (outreachMethod) {
        outreachMethod["MANUAL"] = "manual";
        outreachMethod["AUTOMATIC"] = "automatic";
    })(outreachMethod = DeploymentResponse.outreachMethod || (DeploymentResponse.outreachMethod = {}));
    let outreachTarget;
    (function (outreachTarget) {
        outreachTarget["DIRECT"] = "direct";
        outreachTarget["AGENCY"] = "agency";
    })(outreachTarget = DeploymentResponse.outreachTarget || (DeploymentResponse.outreachTarget = {}));
    let outreachLanguage;
    (function (outreachLanguage) {
        outreachLanguage["EN"] = "en";
        outreachLanguage["ES"] = "es";
        outreachLanguage["RU"] = "ru";
        outreachLanguage["DE"] = "de";
        outreachLanguage["FR"] = "fr";
        outreachLanguage["PT"] = "pt";
        outreachLanguage["KO"] = "ko";
        outreachLanguage["IT"] = "it";
        outreachLanguage["TR"] = "tr";
        outreachLanguage["PL"] = "pl";
        outreachLanguage["PT_BR"] = "pt-BR";
    })(outreachLanguage = DeploymentResponse.outreachLanguage || (DeploymentResponse.outreachLanguage = {}));
    let payoutDestination;
    (function (payoutDestination) {
        payoutDestination["DIRECT"] = "direct";
        payoutDestination["AGENCY"] = "agency";
    })(payoutDestination = DeploymentResponse.payoutDestination || (DeploymentResponse.payoutDestination = {}));
    let status;
    (function (status) {
        status["DRAFT"] = "draft";
        status["ACTIVE"] = "active";
        status["COMPLETED"] = "completed";
    })(status = DeploymentResponse.status || (DeploymentResponse.status = {}));
    let payoutState;
    (function (payoutState) {
        payoutState["UNKNOWN"] = "unknown";
        payoutState["AWAITING_APPROVAL"] = "awaiting_approval";
        payoutState["APPROVED"] = "approved";
        payoutState["REJECTED"] = "rejected";
        payoutState["PROCESSING"] = "processing";
        payoutState["PAID"] = "paid";
        payoutState["FAILED"] = "failed";
    })(payoutState = DeploymentResponse.payoutState || (DeploymentResponse.payoutState = {}));
    let paymentEligibility;
    (function (paymentEligibility) {
        paymentEligibility["AUTOMATIC"] = "automatic";
        paymentEligibility["MANUAL"] = "manual";
    })(paymentEligibility = DeploymentResponse.paymentEligibility || (DeploymentResponse.paymentEligibility = {}));
    let manualPaymentReviewStatus;
    (function (manualPaymentReviewStatus) {
        manualPaymentReviewStatus["NONE"] = "none";
        manualPaymentReviewStatus["PENDING"] = "pending";
        manualPaymentReviewStatus["IN_PROGRESS"] = "in_progress";
        manualPaymentReviewStatus["COMPLETED"] = "completed";
    })(manualPaymentReviewStatus = DeploymentResponse.manualPaymentReviewStatus || (DeploymentResponse.manualPaymentReviewStatus = {}));
})(DeploymentResponse = exports.DeploymentResponse || (exports.DeploymentResponse = {}));
